import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../services/notification.service';
import { Observable } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

import { DeliveriesLoad, DeliveriesLoadSuccess, DeliveryActionTypes } from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentProject } from '@completion/selectors';
import { ProjectService } from '@completion/services';
import { Delivery, Project } from '@completion/models';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class DeliveryEffect {
  constructor(
    private actions$: Actions,
    private service: ProjectService,
    private store: Store<State>,
    private toastr: NotificationService,
  ) {}

  loadDeliveries$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeliveriesLoad>(DeliveryActionTypes.DeliveriesLoad),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>),
      trackResource<Delivery[]>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.service,
        method: 'getDeliveries',
        serviceArgs: ([_, currentProject]) => [currentProject.id],
        onSuccess: (response) => new DeliveriesLoadSuccess(response),
      }),
    ),
  );
}
